export const masterDataTheme = {
  boxToHoldEverything: {
    width: '100%',
    height: 'auto',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
  },

  leftSideBox: {
    width: '47%',
    display: 'flex',
    flexDirection: 'row',
    marginRight: '5px',
    //backgroundColor: 'red',
  },

  rightSideBox: {
    width: '45%',
    display: 'flex',
    flexDirection: 'column',
    marginLeft: '5px',
    backgroundColor: 'transparent',
  },

  sampleDataTitle: {
    fontSize: '20px',
    margin: '10px 1px',
    color: 'grey',
  },

  boxToHoldImage: {
    borderRadius: 10,
    boxShadow: '2px 2px 2px 2px grey',
  },

  sampleImageProperties: { borderRadius: 'inherit' },
};
